import styled from 'styled-components';
import { Switch as BaseSwitch } from '@mui/material';

const Switch = styled(BaseSwitch)`
  width: 32px;
  height: 16px;
  padding: 0;
  & .MuiSwitch-switchBase {
    padding: 0;
    margin: 2px;
    transition-duration: 300ms;
    &.Mui-checked {
      transform: translateX(16px);
      color: ${({ theme }) => theme.palette.common.white};
      & + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.palette.common.black};
        opacity: 1;
        border: 0;
      }

      &.Mui-disabled + .MuiSwitch-track {
        opacity: 0.5;
      }
    }

    &.Mui-focusVisible .MuiSwitch-thumb {
      color: ${({ theme }) => theme.palette.common.black};
      border: 6px solid ${({ theme }) => theme.palette.common.white};
    }

    &.Mui-disabled .MuiSwitch-thumb {
      color: ${({ theme }) => theme.palette.common.white};
    }

    &.Mui-disabled + .MuiSwitch-track {
      opacity: 0.7;
    }
  }

  & .MuiSwitch-thumb {
    box-sizing: border-box;
    width: 12px;
    height: 12px;
  }

  & .MuiSwitch-track {
    border-radius: 13px;
    background-color: ${({ theme }) => theme.palette.common.gray4};
    opacity: 1;
    transition: background-color 0.5s ease;
  }
`;

export default Switch;
